// extracted by mini-css-extract-plugin
export default {"close":"styles_close__VZaXE","closeLineOne":"styles_closeLineOne__678-t","closeLineTwo":"styles_closeLineTwo__fe5cE"};